export enum TebligatEvrakTypeEnum {
    YUZUCDAVETIYESININ_TEBLIGE_CIKARTILMASI = "AvukatTalepTebligat103DavetiyeDVO",
    BakiyeBorcMuhtirasininTebligeCikartilmasi = "AvukatTalepTebligatDosyaHesabiDVO",
    IcraOdemeEmrininTebligeCikartilmasi = "AvukatTalepTebligatOdemeEmriDVO",
    KiymetTakdirininTebligeCikartilmasi = "AvukatTalepTebligatKiymetTakdiriDVO",
    TaahuduKabulMuhtirasiTebligi = "AvukatTalepTebligatTaahhuduKabulMuhtirasiDVO",
    TemlikBilgisininBildirilmesi = "AvukatTalepTebligatTemlikBilgisiDVO",
    YenilemeEmrininTebligeCikartilmasi = "AvukatTalepTebligatDosyaYenilenmesiDVO"
}